export default __webpack_public_path__ + "static/media/thinking-person.b9f7d8d5.svg";